import { createAPIRequest, createAPIResponse } from '@tlx/astro-shared';
import { computeUrl, mapObjectToUrlSearchParams } from '@Util/api.ts';
import { APIUrls } from '@Util/urls.ts';

export const checkAccountingPeriods = async (accountingPeriodIds: Array<string>) => {
    const url = computeUrl(
        APIUrls.CHECK_WAGE_ACCOUNTING_PERIOD,
        mapObjectToUrlSearchParams({
            accountingPeriodIds: accountingPeriodIds.join(','),
        }),
    );
    const request = createAPIRequest(url, { method: 'PUT' });
    const response = await window.fetch(request);
    return await createAPIResponse(request, response);
};
